// extracted by mini-css-extract-plugin
export default {"about_section":"about_about_section__NV0pt"};